import React from 'react'
import { Cell } from 'rsuite-table'
import './TaskStatusCell.scss'

type RowData = {
  [key: string]: string | boolean
}

type TaskStatusCellProps = {
  rowData?: RowData,
  dataKey: string
}

const STATUS_LABEL_MAP: Record<string, string> = {
  PENDING: 'Pending',
  FAILED: 'Failed',
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
  RAW_RESPONSE_SAVED: 'Raw Response Saved',
  UNTRAINED_DOCUMENT: 'Untrained Document'
}

const TaskStatusCell: React.FC<TaskStatusCellProps> = ({
  rowData,
  dataKey,
  ...props
}) => {
  const status = rowData?.[dataKey] as string | undefined

  const lowerCaseStatus = status ? status.toLowerCase().replace(/_/g, '-') : ''

  const displayLabel = status ? (STATUS_LABEL_MAP[status] ?? status) : ''

  return (
    <Cell {...props}>
      <span className={`task-status-badge task-status-${lowerCaseStatus}`}>
        {displayLabel}
      </span>
    </Cell>
  )
}

export default TaskStatusCell
